import CryptoJS from 'crypto-js';

export const ENCRYPTION_KEY = import.meta.env.VITE_ENCRYPTION_KEY;
export const ENCRYPTION_IV = import.meta.env.VITE_ENCRYPTION_IV;

export function decryptPayload(hexString) {
  const key = CryptoJS.enc.Utf8.parse(ENCRYPTION_KEY);
  const iv = CryptoJS.enc.Utf8.parse(ENCRYPTION_IV);
  const encryptedBase64 = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Hex.parse(hexString));

  const decrypted = CryptoJS.AES.decrypt(encryptedBase64, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
}
